export default {
    namespaced: true,
    chatbot_fake: {
      section_master_account: "Sure, I direct you to the view so you can add the master account.",
      default_final_response: "Here is the result:",
      welcome: "Hi, I'm Omniview AI, how can I help you?, I can suggest the following options:",
      bar: "Create bar chart",
      pie: "Create doughnut chart",
      list: "Create list",
      List: "list",
      sugestion_options: "I can suggest the following options:",
      type_event_select: "Select the type of event you want to consult",
      Alarm: "Alarms",
      Camera: "Camera",
      DetectionEvent: "Detection events",
      select_type_group: "Select grouping type",
      status: "Status",
      online: "Status",
      type: "Type Alarm",
      id_tenant: "Tenant",
      id_center: "Center",
      id_sector: "Sector",
      event_type: "Type Event",
      sugestion_filters: "I can suggest the following filters",
      sugestion_filters_metadata: "I can suggest the following filters by metadata",
      metadataOption: "What filters would you like to apply, I can suggest an example: show me the red cars with GCG plates.",
      car: "Car",
      person: "Person",
      tipCard: "Drag this card to some tab",
      ready: "Ready",
      pieName: "Chart doughnut",
      barName: "Chart bar",
      mapName: "Map",
      listName: "list"
    }
  };  